<div class="add-update-license">
  <div class="grower-Info padding-l10">
    <p class="growerName">
      {{grower.growerName}}
    </p>
    <p class="margin-t-25">
      {{grower.growerBusinessName}}
    </p>
    <p *ngIf="growerGLN" class="margin-t-15 addressFont">
      GLN - {{growerGLN}}
    </p>
    <p class="margin-t-25 addressFont">
      {{grower.growerAddress1}} {{grower.growerAddress2}}
    </p>
    <p class="margin-t-25 addressFont">
      <span *ngIf="grower.growerCity || grower.growerState"> {{grower.growerCity}} {{grower.growerState}}</span><span *ngIf="grower.growerZipCode">, {{grower.growerZipCode}}</span>
    </p>
    <p class="margin-t-15 required">
      REQUIRED: <button class="roundedBtn">{{requireddata}}</button>
    </p>
  </div>

  <div class="form-sec">
  </div>
  <div class="row">
    <div class="col-md-12 tabBgColor padding-t10">

      <div class="tableContainer prodTableContainer">

        <table mat-table [dataSource]="licenseDataSource" multiTemplateDataRows class="matTables productTable">
          <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
            <tr class="mat-header-row">
              <div *ngIf="column=='licenseStatus'">
              <th mat-header-cell *matHeaderCellDef class="licenseStatusxCol">&nbsp;</th>
      </div>
      <div *ngIf="column=='manufacturer'"><th mat-header-cell *matHeaderCellDef class="manufacturerBlock">Manufacturer:</th></div>
      <div *ngIf="column=='licenseNumber'"><th mat-header-cell *matHeaderCellDef class="licenseNumberBlock padding-l15">License Number:</th></div>
      </tr>
      <td mat-cell *matCellDef="let element" class="padding-r25">
        <div *ngIf="column=='licenseStatus'" class="text-center LicenseStatusxCol">
          <div title="{{element.licenseStatus}}" *ngIf=""></div>
          <div title="{{element.licenseStatusFull}}" *ngIf="element.licenseStatus==='P'"><span class="dot yellowDot"></span></div>
          <div title="{{element.licenseStatusFull}}" *ngIf="element.licenseStatus==='U'||element.licenseStatus==='N'"><span class="dot redDot"></span></div>
          <div title="{{element.licenseStatusFull}}" *ngIf="element.licenseStatus==='D'"><span class="dot blackDot"></span></div>
          <div title="{{element.licenseStatusFull}}" *ngIf="element.licenseStatus==='L'"><span class="dot greenDot"></span></div>
        </div>

        <div *ngIf="column=='manufacturer'" class="manufacturer-info-outer">
          <h5 class="manufacturer-size margin-b0">{{element.manufacturer}}</h5>
        </div>
        <div *ngIf="column=='licenseNumber'">
          <div class="row input-box">
            <div class="col-10 padding-r0 m-auto">
              <input matInput type="text" maxlength="36" [(ngModel)]="element.licenseNumber" width="200" />
            </div>
            <div class="col-2 padding-l0">
              <button mat-button *ngIf="element.licenseNumber" matSuffix mat-icon-button aria-label="Clear" (click)="element.licenseNumber=''">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
</div>
<div class="row add-order-sec margin-l0 margin-r0">
  <div class="col-md-6 padding-l0">
    <button mat-raised-button class="btns" color="primary" (click)="saveLicenseInfo()">Save License</button>
  </div>
</div>
</div>
